module.exports = __webpack_public_path__ + "static/media/array_of_length_3.6c2456c5.png";